import AppHeader from './components/AppHeader';
import TerminalHero from './components/TerminalHero';
import ScrollVisualization from './components/ScrollVisualization';
import ToolMatrix from './components/ToolMatrix';
import MarketScanner from './components/MarketScanner';
import MarketCalendar from './components/MarketCalendar';
import Footer from './components/Footer';
import { useSeo } from "@/lib/seo";
import AppEnding from './components/AppEnding';

export default function Home() {
  useSeo({
    /* @replace:home-title */
    title: 'ForexMatrix | Công cụ Tính toán & Phân tích Giao dịch Ngoại hối Chuyên nghiệp',
    /* @replace:home-description */
    description: 'Nền tảng công cụ Fintech hàng đầu dành cho Trader. Cung cấp máy tính ký quỹ, tính toán lợi nhuận, phân tích chi phí Spread và mô phỏng tăng trưởng vốn với độ chính xác cao.',
    /* @replace:home-keywords */
    keywords: 'Keywords: tính toán ký quỹ forex, máy tính lợi nhuận ngoại hối, tính chi phí spread, công cụ trade forex, forex matrix',
    path: '/',
  });
  return (
    <div className="relative min-h-screen bg-[#F8FAFC] text-slate-900">
      <AppHeader />
      <main className="pb-8">
        <TerminalHero />
        <ScrollVisualization />
        <ToolMatrix />
        <MarketScanner />
        <MarketCalendar />
      </main>
      <Footer />
      <AppEnding />
    </div>
  );
}